import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './main.css';

const Services = () => {
  const navigate = useNavigate();

  // const handleNavigate = (path: string) => {
  //   navigate(path);
  // };


  const handleNavigate = (id: string) => {
    navigate("/help"); // először navigál a Help oldalra
    setTimeout(() => {  // kis késleltetés, hogy a DOM betöltődjön
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };


  useEffect(() => {
    const faders = document.querySelectorAll('.fade-in');
  
    const appearOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    };
  
    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      });
    }, appearOptions);
  
    faders.forEach((fader, index) => {
      const el = fader as HTMLElement; // ✅ típus assertion
      el.style.transitionDelay = `${index * 0.2}s`;
      appearOnScroll.observe(el);
    });
  
  }, []);

  return (
    <section className="services-wrapper fade-in">
      <h2 className="services-heading">How can we help?</h2>
      <div className="cards-container">
        {/* Kártya 1 */}
        <div className="service-card">
          <h1>Behavioural support</h1>
          <div className="card-text">
          TAG provides organisations with insight into complex human behaviours, empowering them to make relevant, 
          timely and informed decisions. TAG can provide your organisation with behavioural support, personality-based support and/or mental health support.
          </div>
          <div className="read-more" onClick={() => handleNavigate('behavioural-support')}>
          Read More
        </div>
        </div>

        {/* Kártya 2 */}
        <div className="service-card">
          <h1>Personality-based support</h1>
          <div className="card-text">
          Reducing and responding to aggression, violence, and counter-productive workplace behaviour is an organisation’s legal and ethical responsibility.
          </div>
          <div className="read-more" onClick={() => handleNavigate('personality-support')}>
          Read More
        </div>
        </div>

        {/* Kártya 3 */}
        <div className="service-card">
          <h1>Mental health support</h1>
          <div className="card-text">
          Investing in the right people, fostering a positive workplace culture and helping individuals gain insight into themselves is good leadership and reduces risk!
          </div>
          <div className="read-more" onClick={() => handleNavigate('mental-health-support')}>
          Read More
        </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
